export function loadStyles() {
  import("@/assets/css/feather.css");
  import("@/assets/css/main.css");
  }